import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";

const Proximamente = ({
  titulo = "Próximamente",
  descripcion = "Estamos trabajando en esta funcionalidad para ti.",
  icono = "fa-rocket",
  volverUrl = "/dashboard-residente",
  volverTexto = "Volver al inicio",
}) => {
  return (
    <div className="container-fluid">
      <div
        className="row justify-content-center align-items-center"
        style={{ minHeight: "70vh" }}
      >
        <div className="col-lg-6 col-md-8 col-sm-10">
          <Card className="text-center border-0 shadow-lg">
            <Card.Body className="py-5 px-4">
              <div className="mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10"
                  style={{ width: "120px", height: "120px" }}
                >
                  <i className={`fas ${icono} fa-3x text-primary`}></i>
                </div>
              </div>

              <h2 className="text-primary mb-3">{titulo}</h2>

              <p className="text-muted fs-5 mb-4">{descripcion}</p>

              <div className="d-flex justify-content-center align-items-center gap-2 mb-4">
                <div
                  className="spinner-grow spinner-grow-sm text-primary"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <span className="text-muted">En desarrollo...</span>
              </div>

              <div className="border-top pt-4 mt-4">
                <p className="text-muted small mb-3">
                  <i className="fas fa-bell me-2"></i>
                  Te notificaremos cuando esté disponible
                </p>
                <Link to={volverUrl} className="btn btn-primary btn-sm shadow">
                  <i className="fas fa-arrow-left me-2"></i>
                  {volverTexto}
                </Link>
              </div>
            </Card.Body>
          </Card>

          <div className="text-center mt-4">
            <small className="text-muted">
              <i className="fas fa-heart text-danger me-1"></i>
              Gracias por tu paciencia
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Proximamente;
